import React from 'react';
import {FormControl, InputLabel, MenuItem, Select} from '@material-ui/core';
import {SelectChangeType, IngestSelectList} from './IngestConfigTypes';

interface Props {
    value: string;
    handleChange: SelectChangeType;
    placeholder: string;
    values?: IngestSelectList;
}

export default function IngestConfigsToolbarSelect({
    value,
    handleChange,
    placeholder,
    values = {},
}: Props) {
    const formStyle = {
        minWidth: 110,
    };

    return (
        <FormControl style={formStyle}>
            <InputLabel id="ingest-config-status-label">{placeholder}</InputLabel>
            <Select
                labelId="ingest-config-status-label"
                value={value}
                onChange={handleChange}
            >
                <MenuItem value="">
                    <em>All</em>
                </MenuItem>
                {Object.entries(values).map(([key, value]) => (
                    <MenuItem value={key} key={key}>
                        {value}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
